import { createSlice } from "@reduxjs/toolkit";
import {
  fetchStaffGroups,
  fetchStaffGroupById,
  createStaffGroup,
  updateStaffGroup,
  deleteStaffGroup,
} from "@/apis/security/staffGroupsApi";

const staffGroupsSlice = createSlice({
  name: "staffGroups",
  initialState: {
    list: null,
    current: null,
    fieldsEnabled: false,
    listLoading: false,
    currentLoading: false,
    saveLoading: false,
    deleteLoading: false,
  },
  reducers: {
    setFieldsEnabled: (state, action) => {
      state.fieldsEnabled = action.payload;
    },
    clearCurrent: (state) => {
      state.current = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // LIST
      .addCase(fetchStaffGroups.pending, (s) => { s.listLoading = true })
      .addCase(fetchStaffGroups.fulfilled, (s, { payload }) => {
        s.list = payload;
        s.listLoading = false;
      })
      .addCase(fetchStaffGroups.rejected, (s) => { s.listLoading = false })

      // GET BY ID
      .addCase(fetchStaffGroupById.pending, (s) => { s.currentLoading = true })
      .addCase(fetchStaffGroupById.fulfilled, (s, { payload }) => {
        s.current = payload;
        s.currentLoading = false;
      })
      .addCase(fetchStaffGroupById.rejected, (s) => { s.currentLoading = false })

      // CREATE & UPDATE share saveLoading
      .addCase(createStaffGroup.pending, (s) => { s.saveLoading = true })
      .addCase(createStaffGroup.fulfilled, (s, { payload }) => {
        s.list = [...(s.list || []), payload];
        s.current = payload;
        s.saveLoading = false;
      })
      .addCase(createStaffGroup.rejected, (s) => { s.saveLoading = false })

      .addCase(updateStaffGroup.pending, (s) => { s.saveLoading = true })
      .addCase(updateStaffGroup.fulfilled, (s, { payload }) => {
        s.list = (s.list || []).map(g =>
          g.staffGroupsID === payload.staffGroupsID ? payload : g
        );
        s.current = payload;
        s.saveLoading = false;
      })
      .addCase(updateStaffGroup.rejected, (s) => { s.saveLoading = false })

      // DELETE
      .addCase(deleteStaffGroup.pending, (s) => { s.deleteLoading = true })
      .addCase(deleteStaffGroup.fulfilled, (s, { payload }) => {
        s.list = (s.list || []).filter(g => g.staffGroupsID !== payload);
        if (s.current?.staffGroupsID === payload) {
          s.current = null;
        }
        s.deleteLoading = false;
      })
      .addCase(deleteStaffGroup.rejected, (s) => { s.deleteLoading = false });
  },
});

export const { setFieldsEnabled, clearCurrent } = staffGroupsSlice.actions;
export default staffGroupsSlice.reducer;
